import React from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

export default function Help() {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div>
            <Worker workerUrl='/static/js/pdf.worker.min.js'>
                <div className='PdfViewer' style={{ height: '1200px' }}>
                    <Viewer
                        fileUrl='/assets/GSA-037-500 Griffin Event Monitor Manual.pdf'
                        plugins={[defaultLayoutPluginInstance]}
                    />
                </div>
            </Worker>
        </div>
    );
}
